// Dependencies
import { Component } from 'react';
import { connect } from 'react-redux';

import TypeTag from 'components/atoms/TypeTag';
import { FilterObjectType } from 'types/search';
import { translate } from 'utils/translate';

interface AdminShortcutComponentProps {
    handleChange: (value: number) => void;
    filterObject: FilterObjectType;
}

interface AdminShortcutComponentState {
    filterObject: FilterObjectType;
}

class AdminShortcut extends Component<AdminShortcutComponentProps, AdminShortcutComponentState> {
    constructor(props: AdminShortcutComponentProps) {
        super(props);
        this.state = {
            filterObject: props.filterObject,
        };
    }

    render() {
        return (
            <>
                <TypeTag active={this.props.filterObject?.tags.includes(40)} type="system">
                    <div
                        onClick={() => {
                            this.props.handleChange(40);
                        }}
                    >
                        {translate(`For review`)}
                    </div>
                </TypeTag>
            </>
        );
    }
}

const AdminShortcutStateToProps = () => ({});

const AdminShortcutDispatchToProps = () => ({});

export default connect(AdminShortcutStateToProps, AdminShortcutDispatchToProps)(AdminShortcut);
